/**
 * @generated SignedSource<<4baf3e1abf5c599318636e2adfbea0cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HomebaseQuery$variables = {};
export type HomebaseQuery$data = {
  readonly homebase: {
    readonly " $fragmentSpreads": FragmentRefs<"HomebaseGraphs_homebase" | "HomebaseGuidance_homebase" | "HomebaseHeader_homebase" | "HomebaseInsights_homebase" | "HomebaseTable_homebase">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"HomebasePartners_query">;
};
export type HomebaseQuery = {
  response: HomebaseQuery$data;
  variables: HomebaseQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "HomebaseTimeseriesNode",
  "kind": "LinkedField",
  "name": "timeseries",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "x",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "y",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platform",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "current",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percentChange",
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomebaseQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HomebaseNode",
        "kind": "LinkedField",
        "name": "homebase",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HomebaseHeader_homebase"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HomebaseGraphs_homebase"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HomebaseTable_homebase"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HomebaseInsights_homebase"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HomebaseGuidance_homebase"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "HomebasePartners_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HomebaseQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HomebaseNode",
        "kind": "LinkedField",
        "name": "homebase",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HomebaseDataNode",
            "kind": "LinkedField",
            "name": "instagramFollowers",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HomebaseDataNode",
            "kind": "LinkedField",
            "name": "tiktokFollowers",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HomebaseDataNode",
            "kind": "LinkedField",
            "name": "weeklyStreams",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNode",
            "kind": "LinkedField",
            "name": "artist",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ArtistStatsObject",
                "kind": "LinkedField",
                "name": "stats",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ranked",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "streamsThisWeek",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weeklyChange",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GenreNode",
                "kind": "LinkedField",
                "name": "genre",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "genre",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNodeConnection",
                "kind": "LinkedField",
                "name": "profiles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StatWithDelta",
                "kind": "LinkedField",
                "name": "latestSpotifyMonthlyListenerCount",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StatWithDelta",
                "kind": "LinkedField",
                "name": "latestTiktokFollowerCount",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "instagramProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "last",
                        "value": 1
                      }
                    ],
                    "concreteType": "InstagramProfileDataNodeConnection",
                    "kind": "LinkedField",
                    "name": "instagramProfileData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InstagramProfileDataNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InstagramProfileDataNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "avgCommentsPerPost",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "avgLikesPerPost",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "instagramProfileData(last:1)"
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "tiktokProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TikTokSoundNodeConnection",
                    "kind": "LinkedField",
                    "name": "tiktokSounds",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TikTokSoundNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TikTokSoundNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tiktokUrl",
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StatWithDelta",
                                "kind": "LinkedField",
                                "name": "mostRecentStat",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "previous",
                                    "storageKey": null
                                  },
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StatWithDelta",
                "kind": "LinkedField",
                "name": "latestInstagramFollowerCount",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HomebaseDataNode",
            "kind": "LinkedField",
            "name": "spotifyFollowers",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ActionItemNode",
            "kind": "LinkedField",
            "name": "actionItems",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checked",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ActionItemPlatformNodeConnection",
                "kind": "LinkedField",
                "name": "platforms",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ActionItemPlatformNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ActionItemPlatformNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "platformFormatted",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbnailUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "providerName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "providerUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "homebasePartnerLocations",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 3
          },
          {
            "kind": "Literal",
            "name": "locations",
            "value": []
          },
          {
            "kind": "Literal",
            "name": "offset",
            "value": 0
          }
        ],
        "concreteType": "HomebasePartnerNodeConnection",
        "kind": "LinkedField",
        "name": "homebasePartners",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HomebasePartnerNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HomebasePartnerNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v9/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fee",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliverables",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "about",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "homebasePartners(first:3,locations:[],offset:0)"
      }
    ]
  },
  "params": {
    "cacheID": "bf211f296eeb196804a6bdb3e0d95894",
    "id": null,
    "metadata": {},
    "name": "HomebaseQuery",
    "operationKind": "query",
    "text": "query HomebaseQuery {\n  homebase {\n    ...HomebaseHeader_homebase\n    ...HomebaseGraphs_homebase\n    ...HomebaseTable_homebase\n    ...HomebaseInsights_homebase\n    ...HomebaseGuidance_homebase\n  }\n  ...HomebasePartners_query\n}\n\nfragment HomebaseGraphs_homebase on HomebaseNode {\n  instagramFollowers {\n    timeseries {\n      x\n      y\n    }\n  }\n  tiktokFollowers {\n    timeseries {\n      x\n      y\n    }\n  }\n  weeklyStreams {\n    timeseries {\n      x\n      y\n    }\n  }\n  spotifyFollowers {\n    timeseries {\n      x\n      y\n    }\n  }\n}\n\nfragment HomebaseGuidance_actionItem on ActionItemNode {\n  id\n  title\n  thumbnailUrl\n  providerName\n  providerUrl\n  description\n  platforms {\n    edges {\n      node {\n        id\n        platform\n        platformFormatted\n      }\n    }\n  }\n  checked\n  ...useToggleCheckActionItem_actionItem\n}\n\nfragment HomebaseGuidance_homebase on HomebaseNode {\n  actionItems {\n    id\n    checked\n    platforms {\n      edges {\n        node {\n          platform\n          id\n        }\n      }\n    }\n    ...HomebaseGuidance_actionItem\n  }\n}\n\nfragment HomebaseHeader_homebase on HomebaseNode {\n  instagramFollowers {\n    value\n  }\n  tiktokFollowers {\n    value\n  }\n  weeklyStreams {\n    value\n  }\n  artist {\n    displayName\n    location\n    imageUrl\n    stats {\n      ranked\n    }\n    genre {\n      genre\n      id\n    }\n    profiles {\n      edges {\n        node {\n          ...SocialLinksIcons_profiles\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment HomebaseInsights_homebase on HomebaseNode {\n  artist {\n    stats {\n      streamsThisWeek\n      weeklyChange\n    }\n    latestSpotifyMonthlyListenerCount {\n      current\n      percentChange\n    }\n    latestTiktokFollowerCount {\n      current\n      percentChange\n    }\n    instagramProfile {\n      instagramProfileData(last: 1) {\n        edges {\n          node {\n            avgCommentsPerPost\n            avgLikesPerPost\n            id\n          }\n        }\n      }\n      id\n    }\n    tiktokProfile {\n      tiktokSounds {\n        ...RowDeal_useTikTokSoundsTotal\n      }\n      id\n    }\n    latestInstagramFollowerCount {\n      current\n      percentChange\n    }\n    id\n  }\n}\n\nfragment HomebasePartners_partner on HomebasePartnerNode {\n  id\n  name\n  url\n  fee\n  location\n  deliverables\n  about\n}\n\nfragment HomebasePartners_partnerLocations on Query {\n  homebasePartnerLocations\n}\n\nfragment HomebasePartners_partners on Query {\n  homebasePartners(first: 3, offset: 0, locations: []) {\n    edges {\n      node {\n        id\n        ...HomebasePartners_partner\n      }\n    }\n  }\n}\n\nfragment HomebasePartners_query on Query {\n  ...HomebasePartners_partnerLocations\n  ...HomebasePartners_partners\n}\n\nfragment HomebaseTable_homebase on HomebaseNode {\n  instagramFollowers {\n    timeseries {\n      x\n      y\n    }\n  }\n  tiktokFollowers {\n    timeseries {\n      x\n      y\n    }\n  }\n  weeklyStreams {\n    timeseries {\n      x\n      y\n    }\n  }\n  spotifyFollowers {\n    timeseries {\n      x\n      y\n    }\n  }\n}\n\nfragment RowDeal_useTikTokSoundsTotal on TikTokSoundNodeConnection {\n  edges {\n    node {\n      tiktokUrl\n      name\n      mostRecentStat {\n        current\n        previous\n        percentChange\n      }\n      id\n    }\n  }\n}\n\nfragment SocialLinksIcons_profiles on ProfileNode {\n  id\n  url\n  platform\n}\n\nfragment useToggleCheckActionItem_actionItem on ActionItemNode {\n  id\n  checked\n}\n"
  }
};
})();

(node as any).hash = "c36e50be4f2a19be9fe2212bd06c3dd7";

export default node;
